export class TestQuotationLine {
    testCode: string;
    text?: string;
    price?: number;
    sortIndex?: number;
    parameters?: any[];
    code?: string;
    isFavorite?: boolean;
    isSelected?: boolean;
    preparationTestCodes?: string[];
    testName?: string;
    isStructuringQuotationLine?: boolean;
    hideItem = false;
    executionNumber?:number;
}
